const clearLocalStorage = () => localStorage.clear()
const setRefreshToken = (data) => localStorage.setItem('RefreshToken', data);
const setAccessToken = (data) => localStorage.setItem('AccessToken', data);

export {
    clearLocalStorage,
    setRefreshToken,
    setAccessToken
}